/** Namespace `auth` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const auth = {
  serverUnreachable: "Không gọi được máy chủ. Thử lại.",
  devServerUnreachable: "Không gọi được máy chủ dev. Đã chạy `pnpm bube-hq:dev` chưa?",
  email: "Email",
  password: "Mật khẩu",

  "login.subtitle": "Trung tâm kiểm soát nội bộ. Chỉ dành cho nhân viên.",
  "login.submit": "Đăng nhập",
  "login.submitting": "Đang đăng nhập…",
  "login.dev": "Đăng nhập dev (tài khoản chủ) — chỉ máy local",

  "change.title": "Đổi mật khẩu tạm",
  "change.intro": "Mật khẩu tạm đã đi qua màn hình dòng lệnh, nên nó không được dùng lâu.",
  "change.expiresAt": "Hết hạn lúc {at}.",
  "change.current": "Mật khẩu hiện tại",
  "change.new": "Mật khẩu mới",
  "change.minLength": "Từ 12 ký tự.",
  "change.confirm": "Nhập lại mật khẩu mới",
  "change.mismatch": "Hai ô chưa khớp nhau.",
  "change.mismatchSubmit": "Hai ô mật khẩu mới chưa khớp nhau.",
  "change.submit": "Đổi mật khẩu",
  "change.submitting": "Đang lưu…",
} as const;
